export function initialize() {
  // Modaal
  // http://humaan.com/modaal/
  // ----------------------------------------------------------------------------

  $('.has-controls__play, .modaal-video').modaal({
    type: 'video'
  });
}
